/* eslint-disable @typescript-eslint/naming-convention */
import { DbTaellevaerkType } from "./db-taellevaerk-type";

export class DbMaalerType {
    public EMAALTYPE: number;
    public EMAALTYPETEKST: string;
    public FABRIKAT: string;
    public TAELLEVAERKER: DbTaellevaerkType[];
    public PASSIV: boolean;
}
